import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { portal } from '../../src/typings/routes';
import { ToolbarInfoService } from './toolbar-info.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'nav-toolbar',
    templateUrl: './nav-toolbar.component.html',
    styleUrls: ['./nav-toolbar.component.scss']
})
export class NavToolbarComponent implements OnInit {
    public static $name: string = 'navToolbar';

    public parentState: string;
    public parentParams: any;
    public isBackNavEnabled: boolean;
    public parentTitle: string;
    public currentTitle: string;

    @Input() public currentTitleOverride: string;
    @Input() public isBackNavDisabledOverride: boolean;

    constructor(
        private toolbarInfoService: ToolbarInfoService
    ) {
    }

    public ngOnInit() {
        // this is defined in client app

        // Initialize to a known default state so the route directive will not error.
        this.parentState = portal.splashPage;
        this.isBackNavEnabled = false;

        const parentNavMenuItem = this.toolbarInfoService.getParentNavMenuItem();

        if (parentNavMenuItem) {
            this.isBackNavEnabled = true;
            this.parentTitle = parentNavMenuItem.text;
            this.parentState = parentNavMenuItem.state;
            this.parentParams = parentNavMenuItem.stateParams;
        }

        const currentNavMenuItem = this.toolbarInfoService.getCurrentNavMenuItem();

        if (currentNavMenuItem) {
            this.currentTitle = currentNavMenuItem.text;
        }
    }
}
